// Copyright © 2021 Move Closer
/**
 * Hero module variant options.
 */
export var HeroVariant;
(function (HeroVariant) {
    HeroVariant["Standard"] = "standard";
    HeroVariant["Premium"] = "premium";
})(HeroVariant || (HeroVariant = {}));
